import axios from 'axios'
import { env, EnvType } from '../env'
import { Headers, makeUrl, CreateParams, replaceUrlParams, rethrowHttpError } from './utils'

const { facadeBaseUrl, createAgentUser }: EnvType = env


export const create = (headers: Headers) => 
  (resource: string, params: CreateParams) => {
    console.log('create', params)
    const { data } = params
    
    let handleResp = (resp: any) => {
      return resp.data
    }
    let url = '';
    const content: any = data

    switch (resource) {
      case 'employees': {
        url = `${facadeBaseUrl}/${createAgentUser}`
        handleResp = (resp: any) => {
            resp.data['data']['id'] = resp.data['data']['User']['Username']
            return resp.data
        }
        content['enabled'] = true
        content['email_verified'] = true
        if (content['phone_number']) {
          // TODO, this can be smarter; the expected format is +12223334567
          content['phone_number'] = content['phone_number'].length >= 11 ? `+${content['phone_number']}` : `+1${content['phone_number']}`
          content['phone_number_verified'] = true
        }
        break
      }
    }

    console.log(url, headers, content)
    return axios.post(url, content, { headers })
      .then(handleResp)
      .catch(rethrowHttpError)
  }
